module.exports = __webpack_public_path__ + "static/media/27.513182b9.mp3";